import React from 'react'
import { useForm, FormProvider, useFormContext, Controller } from 'react-hook-form'
import styles from './form.module.css'

// Assets
import iconoUsuario from '../../assets/icono-usuario.png'

export const TextField = ({ name = '', label = '', helpText = '', required = false, placeholder = '' }) => {
  const { control } = useFormContext()

  return (
    <Controller
      name={name}
      control={control}
      defaultValue=""
      render={({ field, fieldState }) => (
        <div className={styles.field}>
          <label className={styles.label} htmlFor={name}>{label} {required && <span className={styles.required}>*</span>}</label>

          <div className={styles.shell}>
            <span className={styles.prefix}><img src={iconoUsuario} alt="Usuario" height={17} /></span>
            <input
              id={name}
              className={styles.input}
              type="text"
              value={field.value ?? ''}
              onBlur={field.onBlur}
              onChange={(e) => field.onChange(e.target.value)}
              placeholder={placeholder}
            />
          </div>

          {fieldState.error && <p className={styles.error}>{fieldState.error.message}</p>}

          {helpText && <p className={styles.helpText}>{helpText}</p>}
        </div>
      )}
    />
  )
}